import React from 'react';

import classNames from 'classnames';

export type BlockSectionProps = {
    background?: 'light' | 'dark' | 'np-green' | 'none';
    narrowContainer?: boolean;
    noPaddingTop?: boolean;
    children: React.ReactNode;
    className?: string;
    id?: string;
};

export default function BlockSection({
    background = 'light',
    noPaddingTop,
    className,
    children,
    id,
}: BlockSectionProps) {
    return (
        <section
            id={id}
            className={classNames(className, {
                'py-8 md:py-16 lg:py-24': !noPaddingTop,
                'pb-8 md:pb-16 lg:pb-24': noPaddingTop,
                'bg-bg-lighter text-neutral-900': background === 'light',
                'bg-primary-400 text-neutral-900': background === 'np-green',
                'bg-neutral-900 text-neutral-100': background === 'dark',
            })}
        >
            {children}
        </section>
    );
}
